import useLocation from '../../../hooks/useLocation';
import { isGlobalToolbarExcludedRoute } from '../utils/isGlobalToolbarExcludedRoute';
export function useIsGlobalToolbarExcludedRoute() {
  const {
    pathname
  } = useLocation();
  const isGlobaltoolbarExcludedRoute = isGlobalToolbarExcludedRoute(pathname);
  return {
    isGlobaltoolbarExcludedRoute
  };
}